if (typeof debounce === 'undefined') {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */

if (!customElements.get('theme-header')) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();

    }
    connectedCallback() {
      this.header_section = document.querySelector('.header-section');
      this.menu = this.querySelector('#mobile-menu');
      this.toggle = this.querySelector('.mobile-toggle-wrapper');

      this.isTransitioning = false;
      this.lastScrollPos = 0;

      document.addEventListener('keyup', (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === 'ESCAPE') {
            this.toggle.removeAttribute('open');
            this.toggle.classList.remove('active');
          }
        }
      });
      if (this.classList.contains('header-sticky--active')) {
        document.body.classList.add('header-sticky--active');
      }
      this.toggle.querySelector('.mobile-toggle').addEventListener('click', (e) => {
        if (this.toggle.classList.contains('active')) {
          e.preventDefault();
          document.body.classList.remove('overflow-hidden');
          this.toggle.classList.remove('active');
          this.closeAnimation(this.toggle);
        } else {
          document.body.classList.add('overflow-hidden');
          setTimeout(() => {
            this.toggle.classList.add('active');
          });
        }
      });

      // Sticky Header Class
      window.addEventListener('scroll', this.setStickyClass.bind(this), {
        passive: true
      });

      // Mobile Menu offset
      window.addEventListener('scroll', this.setHeaderOffset.bind(this), {
        passive: true
      });
      window.addEventListener('scroll', this.setHeaderHeight.bind(this), {
        passive: true
      });

      // Pin / Unpin
      window.addEventListener('scroll', this.handleScroll.bind(this));

      window.dispatchEvent(new Event('scroll'));

      if (document.querySelector('.announcement-bar-section')) {

         window.addEventListener('scroll', this.setAnnouncementHeight(), {
          passive: true
        });
        window.dispatchEvent(new Event('resize'));
      }

      // Mobile Navigation transparent header support.
      setTimeout(() => {
        this.mobile_nav = document.querySelector('.header-mobile-navigation');

        if (this.mobile_nav && this.classList.contains('transparent--true')) {
          this.mobile_nav.classList.add('is-fixed');
        }
      }, 100);
      // Buttons.
      this.menu.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
      this.menu.querySelectorAll('.parent-link-back--button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }
    setStickyClass() {
      if (this.classList.contains('header-sticky--active')) {
        let offset = parseInt(this.getBoundingClientRect().top, 10) + document.documentElement.scrollTop;
        this.classList.toggle('is-sticky', window.scrollY >= offset && window.scrollY > 0);
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.querySelector('.announcement-bar-section');
      let h = a_bar.clientHeight;
      document.documentElement.style.setProperty('--announcement-height', h + 'px');
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty('--header-offset', h + 'px');
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--header-height', h + 'px');
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest('.link-container');
      const isOpen = detailsElement.hasAttribute('open');
      if (this.querySelector('.parent-link-back--button')) {
        this.menu.scrollTop = 0;
      }
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest('details');
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove('menu-opening');
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute('open');
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }

    handleScroll() {
      if (!this.isTransitioning && this.classList.contains('header-hide-menu--active')) {
        if (document.documentElement.scrollTop < 200) {
          this.showMenu();
        } else if (this.lastScrollPos < document.documentElement.scrollTop) {
          this.hideMenu();
        } else if (this.lastScrollPos - 5 > document.documentElement.scrollTop) {
          this.showMenu();
        }

        this.lastScrollPos = document.documentElement.scrollTop;
      }
    }

    showMenu() {
      this.classList.remove('header--unpin');
      this.isTransitioning = true;
      setTimeout(() => {
        this.lastScrollPos = document.documentElement.scrollTop;
        this.isTransitioning = false;
        this.handleScroll();
      }, 300);
    }
    hideMenu() {
      if (!this.isTransitioning) {
        this.classList.add('header--unpin');
        this.isTransitioning = true;
        setTimeout(() => {
          this.lastScrollPos = document.documentElement.scrollTop;
          this.isTransitioning = false;
          this.handleScroll();
        }, 300);
      }
    }
  }
  customElements.define('theme-header', ThemeHeader);
}

if (!customElements.get('full-menu')) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
      this.submenus = this.querySelectorAll('.thb-full-menu > .menu-item-has-children:not(.menu-item-has-megamenu) > .sub-menu');
    }

    connectedCallback() {

      const _this = this;

      // Resize on initial load
      document.fonts.ready.then(() => {
        window.addEventListener('resize', debounce(() => {

          _this.setMenuHeight();
          if (!this.submenus.length) {
            return;
          }
          _this.resizeSubMenus();
        }, 100));
      });

      this.setMenuHeight();
    }

    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        const subSubmenus = submenu.querySelectorAll(':scope > .menu-item-has-children > .sub-menu');

        subSubmenus.forEach((subSubmenu) => {
          const submenuRect = subSubmenu.getBoundingClientRect();
          const submenuRightEdge = submenuRect.left + submenuRect.width;
          const submenuIsOverflowing = submenuRightEdge > window.innerWidth;

          if (submenuIsOverflowing) {
            subSubmenu.parentElement.classList.add('left-submenu');
          } else {
            subSubmenu.parentElement.classList.remove('left-submenu');
          }
        });
      });
    }
    setMenuHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty('--menu-height', h + 'px');
    }
  }

  customElements.define('full-menu', FullMenu);
}

(function () {
  const vatToggle = document.querySelector('[data-vat-toggle]');
  if (!vatToggle) {
    return;
  }

  const STORAGE_KEY = 'theme.vatDisplay';
  const normaliseState = (value) => (value === 'ex' ? 'ex' : 'inc');
  const defaultState = normaliseState(vatToggle.dataset.default);
  let persistedState = defaultState;
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    if (stored) {
      persistedState = stored;
    }
  } catch (e) {
    persistedState = defaultState;
  }

  let currentState = normaliseState(persistedState);
  const buttons = Array.from(vatToggle.querySelectorAll('[data-vat-option]'));

  const formatValue = (cents, format) => {
    if (typeof formatMoney === 'function') {
      return formatMoney(cents, format);
    }

    const amount = (cents / 100).toFixed(2);
    if (!format) {
      return amount;
    }
    return format.replace('{{amount}}', amount).replace('{{ amount }}', amount);
  };

  const updateButtons = () => {
    buttons.forEach((button) => {
      const isActive = normaliseState(button.dataset.vatOption) === currentState;
      button.setAttribute('aria-pressed', isActive);
      button.classList.toggle('is-active', isActive);
    });
  };

  const updatePrices = (state, root = document) => {
    const scope = root instanceof Element ? root : document;
    const elements = new Set();

    if (scope instanceof Element && scope.dataset.priceInc !== undefined) {
      elements.add(scope);
    }

    scope.querySelectorAll('[data-price-inc]').forEach((el) => elements.add(el));

    const formatFallback = window.theme && window.theme.settings && window.theme.settings.money_with_currency_format;

    elements.forEach((el) => {
      const centsAttr = state === 'ex' ? el.dataset.priceEx : el.dataset.priceInc;
      if (!centsAttr) {
        return;
      }

      const cents = parseInt(centsAttr, 10);
      if (Number.isNaN(cents)) {
        return;
      }

      const format = el.dataset.moneyFormat || formatFallback;
      const formatted = formatValue(cents, format);
      if (formatted !== undefined) {
        el.innerHTML = formatted;
      }
    });
  };

  const applyState = (state, { save = true, context } = {}) => {
    currentState = normaliseState(state);

    if (save) {
      try {
        window.localStorage.setItem(STORAGE_KEY, currentState);
      } catch (e) {
        // Ignore storage exceptions (e.g., private mode)
      }
    }

    if (document.documentElement.dataset.vatDisplay !== currentState) {
      document.documentElement.dataset.vatDisplay = currentState;
    }
    document.dispatchEvent(new CustomEvent('vat:change', { detail: { mode: currentState } }));
    updateButtons();
    updatePrices(currentState, context || document);
  };

  vatToggle.addEventListener('click', (event) => {
    const option = event.target.closest('[data-vat-option]');
    if (!option) {
      return;
    }

    const requestedState = normaliseState(option.dataset.vatOption);
    if (requestedState === currentState) {
      return;
    }

    applyState(requestedState);
  });

  if (document.documentElement.dataset.vatDisplay !== currentState) {
    document.documentElement.dataset.vatDisplay = currentState;
  }
  updateButtons();
  updatePrices(currentState);

  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target) {
      return;
    }
    updatePrices(currentState, event.target);
  });

  
})();
